import { FiCompass, FiGlobe, FiKey, FiPieChart, FiUserPlus  } from "react-icons/fi";
import { MdGridOn  } from "react-icons/md";
import { GoBug, GoDatabase, GoLock, GoLink } from "react-icons/go";
import { HiOutlineGlobe } from "react-icons/hi";
import { LuSettings, LuLaptop, LuBox } from "react-icons/lu";
import { AiOutlineFileAdd } from "react-icons/ai";
import { FaFire } from "react-icons/fa6";

export const MENU = [
  {
    title: "Dashboard",
    icon: MdGridOn,
    route: "/dashboard",
  },
  {
    title: "Targets",
    icon: FiGlobe,
    route: "/dashboard/assets",
  },
  {
    title: "Inventory",
    icon: AiOutlineFileAdd,
    route: "/dashboard/inventory",
  },
  {
    title: "Credentials",
    icon: FiKey,
    route: "/dashboard/credentials",
  },
  {
    title: "Scans",
    icon: FiCompass,
    route: "/dashboard/scan-history",
  },
  {
    title: "Insights",
    icon: FiPieChart,
    route: "/dashboard/insights",
  },
  {
    title: "Team",
    icon: FiUserPlus ,
    route: "/dashboard/team",
  },
];

export const VIEWER = [
  {
    title: "Dashboard",
    icon: MdGridOn,
    route: "/dashboard",
  },
  {
    title: "Targets",
    icon: FiGlobe,
    route: "/dashboard/assets",
  },
  {
    title: "Inventory",
    icon: AiOutlineFileAdd,
    route: "/dashboard/inventory",
  },
  {
    title: "Scans",
    icon: FiCompass,
    route: "/dashboard/scan-history",
  },
  {
    title: "Insights",
    icon: FiPieChart,
    route: "/dashboard/insights",
  },
];

export const Categories = [
  {
    title: "Software Bugs",
    icon: GoBug,
    color: "#E53935",
    background: "#E539351A",
  },
  {
    title: "Web Vulnerabilities",
    icon: HiOutlineGlobe,
    color: "#FB8C00",
    background: "#FB8C001A",
  },
  {
    title: "Database Vulnerabilities",
    icon: GoDatabase,
    color: "#26A69A",
    background: "#26A69A1A",
  },
  {
    title: "Container/Kubernetes Issues",
    icon: LuSettings,
    color: "#42A5F5",
    background: "#42A5F51A",
  },
  {
    title: "Firewall/Misconfigurations",
    icon: FaFire,
    color: "#D32F2F",
    background: "#D32F2F1A",
  },
  {
    title: "Authorization Issues",
    icon: GoLock,
    color: "#7E57C2",
    background: "#7E57C21A",
  },
  {
    title: "Server Misconfigurations",
    icon: GoLink,
    color: "#8D6E63",
    background: "#8D6E631A",
  },
  {
    title: "Third-Party Risks",
    icon: LuLaptop,
    color: "#757575",
    background: "#7575751A",
  },
  {
    title: "Others",
    icon: LuLaptop,
    color: "#757575",
    background: "#7575751A",
  },
  {
    title: "Outdated Software",
    icon: LuBox,
    color: "#FFB300",
    background: "#FFB3001A",
  },
];

export const severities = [
  { value: "all", label: "All" },
  { value: "Low", label: "Low" },
  { value: "Log", label: "Info" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Critical", label: "Critical" },
];